import type { AxiosPromise } from "axios";
import { apiClient } from "@/api/modules/base";

import type {
    NutritionStatementsListItem,
    NutritionStatementsListRequest
} from "@/api/modules/autoQ/nutritionStatements/types";
import { Route } from "@/api/modules/autoQ/nutritionStatements/route";

export const list = (payload: NutritionStatementsListRequest): AxiosPromise<NutritionStatementsListItem[]> =>
    apiClient.get(Route.NutritionStatements, {
        params: {
            productId: payload.productId,
            nutritionStatementIds: payload.nutritionStatementIds
        }
    });
